var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.6011L5.8983 21.5L11.3932 17.4138C11.5855 17.2708 11.7382 17.101 11.8423 16.9142C11.9464 16.7273 12 16.5271 12 16.3248V6.67269C12 6.47039 11.9464 6.27017 11.8423 6.0833C11.7382 5.89645 11.5855 5.72668 11.3932 5.58368L5.90169 1.5L2.00339 4.39891L10.0864 10.4098C10.2789 10.5529 10.4315 10.7228 10.5356 10.9098C10.6397 11.0968 10.6932 11.2972 10.693 11.4996C10.6929 11.702 10.639 11.9024 10.5347 12.0893C10.4303 12.2762 10.2775 12.446 10.0848 12.589L2 18.6011Z",
    fill: "#736CF5",
    stroke: "#736CF5",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenArrow);
export default __webpack_public_path__ + "static/media/token-arrow.9088da35144003e7868c3c71f8ae5daf.svg";
export { ForwardRef as ReactComponent };